exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "html,\nbody {\n  box-sizing: border-box;\n  min-width: 100%;\n  min-height: 100%; }\n\nbody {\n  background: linear-gradient(180deg, #AA6B39, #AA6B39 75%, #7D4011);\n  margin-bottom: 200px; }\n\n*,\n*::before,\n*::after {\n  box-sizing: inherit; }\n\n.canvas-wrapper {\n  max-height: 100%;\n  max-width: 100%;\n  padding-bottom: 1rem;\n  background-color: #AA6B39; }\n  @media (min-width: 799px) {\n    .canvas-wrapper {\n      padding-top: 1rem; } }\n\n#main-canvas {\n  border: solid 1px black;\n  max-width: 100%;\n  max-height: 100vh;\n  margin: auto;\n  display: block; }\n\n.canvas-overlay {\n  position: relative;\n  pointer-events: none;\n  max-width: 100%;\n  max-height: 100vh;\n  z-index: 1; }\n\n.ui-container {\n  margin-top: 1em; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/index.scss
// module id = 63
// module chunks = 0